import { useAuth } from 'hooks/useAuth';
import { useMemo } from 'react';
import HomeLayout from 'layouts/home-layout';

function NotFound() {
  const { isAuthenticated } = useAuth();

  const content = useMemo(
    () => (
      <div className="flex flex-col items-center justify-center h-screen text-center">
        <h1 className="text-2xl font-bold text-blue-600">Not Found</h1>
        <p className="text-lg text-gray-600">
          The page you are looking for does not exist.
        </p>
      </div>
    ),
    []
  );

  if (isAuthenticated) {
    return <HomeLayout title="">{content}</HomeLayout>;
  }

  return <>{content}</>;
}

export default NotFound;
